import React, { useState, useEffect } from 'react';

export const STORE_NAME = 'MQTT_STATUS';

export default function useStorage() {
  const [env, setEnv] = useState<string>('');
  const [host, setHost] = useState<string>('');
  const [user, setUser] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [operator, setOperator] = useState<string>('+');
  const [isLoaded, setIsLoaded] = useState<boolean>(false);

  function getLocalData() {
    try {
      if (window.localStorage[STORE_NAME]) {
        return JSON.parse(window.localStorage.getItem(STORE_NAME) || '{}');
      }
    } catch (ex) {
      console.log(ex);
    }
    return {};
  }

  useEffect(() => {
    const data = getLocalData();

    setEnv(data?.env || 'prod');
  }, []);

  useEffect(() => {
    if (env === '') {
      return;
    }
    const data = getLocalData();

    const envData = data[env];

    setHost(envData?.host || '');
    setUser(envData?.user || '');
    setPassword(envData?.password || '');
    setOperator(data.operator || '+');
    setIsLoaded(true);
  }, [env]);

  function save() {
    const data = getLocalData();

    const updData = {
      ...data,
      [env]: {
        host,
        user,
        password,
      },
      operator: operator,
      env: env,
    };

    window.localStorage.setItem(STORE_NAME, JSON.stringify(updData));
  }

  return {
    env,
    setEnv,
    host,
    setHost,
    user,
    setUser,
    password,
    setPassword,
    operator,
    setOperator,
    save,
    isLoaded,
  };
}
